import React from 'react';
import PaymentIcon from '@mui/icons-material/Payment';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import BookmarkIcon from '@mui/icons-material/Bookmark';
import { Lock } from "@mui/icons-material"; 
import { PieChart, Pie, Cell, ResponsiveContainer } from 'recharts';
import styles from './BillingMain.module.css';

const BillingMain = () => {
  const clientSpacesData = [
    { name: 'Used', value: 80 },
    { name: 'Remaining', value: 20 }
  ];
  
  const aiScoreData = [
    { name: 'Used', value: 95 },
    { name: 'Remaining', value: 5 }
  ];
  
  const teamSeatsData = [
    { name: 'Used', value: 95 },
    { name: 'Remaining', value: 5 }
  ];
  
  const COLORS = ['#7c4dff', '#e0e0e0'];

  return (
    <>
      <div className={styles.bannerSoon}>This feature will be available soon.</div>
      <div className={styles.container}>
        <div className={styles.leftContainer}>
          <div className={styles.billingSection}>
            <h2 className={styles.title}>Billing</h2>
            <p className={styles.text}>Manage your profile and preferences here.</p>
            
            <div className={styles.paymentCardSection}>
              <div className={styles.sectionHeader}>
                <div className={styles.icon}>
                  <PaymentIcon style={{ color: '#7c4dff' }} />
                </div>
                <div className={styles.sectionTitle}>
                  <h3 className={styles.subtitle}>Payment card</h3>
                  <p className={styles.text}>Add or change your billing method</p>
                </div>
              </div>
              
              <div className={styles.billingCardForm}>
                <h4 className={styles.smallTitle}>Billing card</h4>
                <div className={styles.cardInputs}>
                  <input type="text" placeholder="Card number" className={styles.input} />
                  <div className={styles.cardExtras}>
                    <input type="text" placeholder="MM / YY" className={styles.input} />
                    <input type="text" placeholder="CVC" className={styles.input} />
                    <div className={styles.secureBadge}>
                      <Lock className={styles.lockIcon} /> Secured by Stripe
                    </div>
                  </div>
                </div>
                <div className={styles.billingDetails}>
                  <div className={styles.zipInput}>
                    <label className={styles.label}>Billing zip code</label>
                    <input type="text" placeholder="e.g: 90500" className={styles.input} />
                  </div>
                  <div className={styles.nameInput}>
                    <label className={styles.label}>Name on your card</label>
                    <input type="text" placeholder="e.g: John Smith" className={styles.input} />
                  </div>
                </div>
                
                <button className={styles.changeCardButton}> ✓ Change card</button>
              </div>
            </div>
            
            <div className={styles.subscriptionSection}>
              <div className={styles.sectionHeader}>
                <div className={styles.icon}>
                  <ShoppingCartIcon style={{ color: '#7c4dff' }} />
                </div>
                <div className={styles.sectionTitle}>
                  <h3 className={styles.subtitle}>Current subscription</h3>
                  <p className={styles.text}>View and edit your subscription</p>
                </div>
              </div>
              
              <div className={styles.subscriptionDetails}>
                <div className={styles.planInfo}>
                  <h4 className={styles.smallTitle}>PLAN</h4>
                  <p className={styles.planName}>Free</p>
                  <button className={styles.changeButton}>Change</button>
                </div>
                
                <div className={styles.seatsInfo}>
                  <h4 className={styles.smallTitle}>SEATS</h4>
                  <p className={styles.seatsCount}>1/1</p>
                  <button className={styles.editButton}>Edit</button>
                </div>
                
                <div className={styles.renewalInfo}>
                  <h4 className={styles.smallTitle}>NEXT RENEWAL</h4>
                  <p className={styles.renewalDate}>Mar 1, 2024</p>
                  <p className={styles.text}>You will receive a refill.</p>
                </div>
              </div>
            </div>
            
            <div className={styles.billingHistorySection}>
              <div className={styles.sectionHeader}>
                <div className={styles.icon}>
                  <BookmarkIcon style={{ color: '#7c4dff' }} />
                </div>
                <div className={styles.sectionTitle}>
                  <h3 className={styles.subtitle}>Billing history</h3>
                  <p className={styles.text}>View and download your past invoices</p>
                </div>
              </div>
              
              <div className={styles.historyTable}>
                <div className={styles.tableHeader}>
                  <div className={styles.descriptionCol}>Description</div>
                  <div className={styles.amountCol}>Amount</div>
                  <div className={styles.statusCol}>Status</div>
                  <div className={styles.dateCol}>Date</div>
                </div>
                
                <div className={styles.tableBody}>
                </div>
              </div>
            </div>
          </div>
        </div>
        
        <div className={styles.rightContainer}>
          <div className={styles.accountUsageSection}>
            <h2 className={styles.title}>Account Usage</h2>
            <p className={styles.text}>Monitor your account limits here</p>
            
            <div className={styles.usageChartsContainer}>
              <div className={styles.chartsRow}>
                <div className={styles.chartContainer}>
                  <div className={styles.chartWrapper}>
                    <ResponsiveContainer width="100%" height={150}>
                      <PieChart>
                        <Pie
                          data={clientSpacesData}
                          cx="50%"
                          cy="50%"
                          innerRadius={40}
                          outerRadius={60}
                          fill="#8884d8"
                          paddingAngle={5}
                          dataKey="value"
                        >
                          {clientSpacesData.map((entry, index) => (
                            <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                          ))}
                        </Pie>
                      </PieChart>
                    </ResponsiveContainer>
                  </div>
                  <div className={styles.chartInfo}>
                    <div className={styles.chartValue}>20</div>
                    <div className={styles.chartLabel}>Client Spaces Remaining</div>
                  </div>
                </div>
                
                <div className={styles.chartContainer}>
                  <div className={styles.chartWrapper}>
                    <ResponsiveContainer width="100%" height={150}>
                      <PieChart>
                        <Pie
                          data={aiScoreData}
                          cx="50%"
                          cy="50%"
                          innerRadius={40}
                          outerRadius={60}
                          fill="#8884d8"
                          paddingAngle={5}
                          dataKey="value"
                        >
                          {aiScoreData.map((entry, index) => (
                            <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                          ))}
                        </Pie>
                      </PieChart>
                    </ResponsiveContainer>
                  </div>
                  <div className={styles.chartInfo}>
                    <div className={styles.chartValue}>5</div>
                    <div className={styles.chartLabel}>AI Call Score Credits Remaining</div>
                  </div>
                </div>
              </div>
              
              <div className={`${styles.chartsRow} ${styles.singleChart}`}>
                <div className={styles.chartContainerBelow}>
                  <div className={styles.chartWrapper}>
                    <ResponsiveContainer width="100%" height={150}>
                      <PieChart>
                        <Pie
                          data={teamSeatsData}
                          cx="50%"
                          cy="50%"
                          innerRadius={40}
                          outerRadius={60}
                          fill="#8884d8"
                          paddingAngle={5}
                          dataKey="value"
                        >
                          {teamSeatsData.map((entry, index) => (
                            <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                          ))}
                        </Pie>
                      </PieChart>
                    </ResponsiveContainer>
                  </div>
                  <div className={styles.chartInfo}>
                    <div className={styles.chartValue}>5</div>
                    <div className={styles.chartLabel}>Team Seats Remaining</div>
                  </div>
                </div>
              </div>
            </div>
            
          <div className={styles.upgradeButtonContainer}>
              <button className={styles.upgradeButton}>
                  Upgrade Limits
              </button>
          </div>
          </div>
          
          <div className={styles.clientServicesSection}>
            <h2 className={styles.title}>Your Client Services Executive</h2>
            <p className={styles.text}>Looking for assistance with your account? We're here to help!</p>
            
            <div className={styles.executiveProfile}>
              <div className={styles.profilePhoto}></div>
              <div className={styles.profileInfo}>
                <h3 className={styles.subtitle}>Jane Smith</h3>
                <p className={styles.phone}>555-555-5555</p>
                <p className={styles.email}>Hello@ClientBloom.ai</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default BillingMain;